import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Button } from "../../../common";
import * as style from "../styles.module.scss";
import FileDropzone from "../../../common/FileDropzone/FileDropzone";

const ProfilePicture = ({
  appData,
  handleProfilePictureSubmitted,
  navigateBackPath,
}) => {
  const imageUploadOptions = {
    maxWidth: 1000,
    maxHeight: 1000,
    contain: false,
  };

  const [isProfileImageValid, setProfileImageValid] = useState(true);
  const [file, setFile] = useState(
    appData && appData.profileImage && appData.profileImage.previewContent
  );
  const handleSubmit = () => handleProfilePictureSubmitted(file);

  return (
    <div className={`col-sm-12 col-lg-6 mt-2 mt-lg-4 mb-2 ${style.form}`}>
      <FileDropzone
        dropFileMsg="Drop your profile image here"
        fileTypeHint="This should be a JPEG or PNG file."
        acceptedFileTypes=".jpg,.jpeg,.png"
        handleChange={(fileStateName, value) => {
          setFile(value);
        }}
        fileStateName="selfieFile"
        fileParsedToString={file}
        handleInvalidType={() => {
          setProfileImageValid(true);
        }}
        isFileValid={isProfileImageValid}
        wrongFileTypeHint="Your image needs to be provided as a JPEG or PNG file."
        fileCategory="image"
        width="unset"
        imageMaxWidth="100%"
        imageUploadOptions={imageUploadOptions}
        url={appData.profileImage && appData.profileImage.url}
      />

      <div className={`mt-lg-auto mt-1 mb-lg-2 ${style.actions}`}>
        <Link to={navigateBackPath}>
          <button className="btn btn-outline-info text-dark mr-1" type="button">
            Back
          </button>
        </Link>
        <Button classes="btn btn-primary btn-block" onClick={handleSubmit}>
          Next
        </Button>
      </div>
    </div>
  );
};

export default ProfilePicture;
